// Just an experimental way of handling fetch states

export const enum FetchHookLifecycle {
  LOADING = 'LOADING',
  ERROR = 'ERROR',
  SUCCESS = 'SUCCESS'
}

export interface FetchBase<T> {
  type: T
}

export interface FetchSuccess<R> extends FetchBase<FetchHookLifecycle.SUCCESS> {
  data: R
}

export interface FetchError<E extends Error = Error>
  extends FetchBase<FetchHookLifecycle.ERROR> {
  error: E
}

export interface FetchLoading extends FetchBase<FetchHookLifecycle.LOADING> {}

export type FetchHook<R, E extends Error = Error> =
  | FetchSuccess<R>
  | FetchLoading
  | FetchError<E>

export function componentResolver<
  F extends FetchBase<T>,
  P extends {
    [K in FetchBase<F['type']>['type']]: React.FC<
      F extends { type: K } ? F : never
    >
  },
  T extends FetchHookLifecycle
>(state: F, props: P) {
  const Component = props[state.type]
  return <Component {...(state as any)} />
}
